module.exports = __webpack_public_path__ + "media/images/accountSection__settingsClose--dark-595dfc86806b67976dd3a2703b7c68c9.png";